// extracted by mini-css-extract-plugin
export default {"row":"TagsColorList-module__row","dropdownMenu":"TagsColorList-module__dropdownMenu"};